import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useHashState} from 'utils/hashState';
import {CustomerServiceParcelInitialValue, CustomerServiceOrderFiltersType} from './graphql/types/CustomerServiceOrderFiltersType';
import {CustomerServiceParcelColumns} from './components/CustomerServiceParcelColumns';
import QualityControlLayout from '../layouts/QualityControlLayout';
import {OrderType} from '../../../graphql/types/OrderType';
import {useCustomerServiceParcelQuery} from './hooks/useCustomerServiceParcelQuery';
import CentralParcelDetailDrawer from '../../central/parcels/components/CentralParcelDetailDrawer';
import CustomerServiceParcelFilter from './components/CustomerServiceParcelFilter';
import { getUserInfo } from '../../../utils/auth';
import TablePaginationBar from '../../../components/TablePaginationBar';

const CustomerServiceParcelsPage: React.FC = () => {
    const {t} = useTranslation();
    const [detailVisible, setDetailVisible] = useState(false);
    const [orderId, setOrderId] = useState<string>('');
    const [tempFilters, setTempFilters] = useHashState(CustomerServiceParcelInitialValue);
    const [filters, setFilters] = useHashState(CustomerServiceParcelInitialValue);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const {
        parcelData,
        loading,
        refetch,
        totalElements,
        accessiblePages,
        buildQueryVariables
    } = useCustomerServiceParcelQuery(filters, currentPage, pageSize);

    const handleResetFilters = () => {
        setTempFilters(CustomerServiceParcelInitialValue);
        setFilters(CustomerServiceParcelInitialValue);
    };

    const handleFilter = () => {
        setFilters(tempFilters);
        setCurrentPage(1);
    };

    const showParcelDetail = (record: OrderType) => {
        setOrderId(record.id);
        setDetailVisible(true);
    };

    const handlePageChange = (page: number, pageSize: number) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    return (
            <div className="bg-white rounded-lg shadow-sm px-3 pb-3 pt-0">
                <CustomerServiceParcelFilter
                    filters={tempFilters}
                    setFilters={setTempFilters}
                    handleFilter={handleFilter}
                    handleResetFilters={handleResetFilters}
                />

                <CustomerServiceParcelColumns
                    parcelData={parcelData}
                    showParcelDetail={showParcelDetail}
                    loading={loading}
                />

                <TablePaginationBar
                    total={totalElements}
                    current={currentPage}
                    pageSize={pageSize}
                    onChange={handlePageChange}
                    pageSizeOptions={['10', '20', '50', '100']}
                    maxPages={accessiblePages}
                />

                <CentralParcelDetailDrawer
                    visible={detailVisible}
                    orderId={orderId}
                    onClose={() => setDetailVisible(false)}
                    userRole={getUserInfo()?.account?.role?.name || ''}
                    showExternalTrack={true}
                />
            </div>
    );
};

export default CustomerServiceParcelsPage;

